import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { injectIntl, intlShape } from 'react-intl';

import styles from './styles';
import messages from './messages';
import {
  getTotalUnreadMessageCount,
  getCompanyHistorySetting,
  getTotalUnreadMessageCountInActiveSession,
} from '../../chat/app/ChatApp/selectors';

export class IconUnreadBadge extends PureComponent {
  renderUnread() {
    const { unreadMessageCount, activeSessionUnreadMessageCount, showHistory } = this.props;

    if (!showHistory) return activeSessionUnreadMessageCount;

    return unreadMessageCount;
  }

  render() {
    const { unreadMessageCount, showHistory, activeSessionUnreadMessageCount, intl } = this.props;

    if (!unreadMessageCount) return null;

    if (!showHistory && !activeSessionUnreadMessageCount) return null;

    return (
      <div
        className="minimizedUnreadIcon"
        style={styles.unread}
        aria-live="assertive"
        aria-label={intl.formatMessage(messages.aria_label_unread_message_count, { unreadMessageCount })}
      >
        {this.renderUnread()}
      </div>
    );
  }
}

IconUnreadBadge.propTypes = {
  unreadMessageCount: PropTypes.number,
  activeSessionUnreadMessageCount: PropTypes.number,
  showHistory: PropTypes.bool,
  intl: intlShape.isRequired,
};

IconUnreadBadge.defaultProps = {
  unreadMessageCount: 0,
  activeSessionUnreadMessageCount: 0,
  showHistory: false,
};

export const mapStateToProps = state => {
  return {
    unreadMessageCount: getTotalUnreadMessageCount(state),
    activeSessionUnreadMessageCount: getTotalUnreadMessageCountInActiveSession(state),
    showHistory: getCompanyHistorySetting(state),
  };
};

export const componentWithIntl = injectIntl(IconUnreadBadge);

export default connect(mapStateToProps)(componentWithIntl);
